define('view/controller/booking/BookingInfoView',['require','lib/view/LayoutView'],function (require) {

	var LayoutView = require('lib/view/LayoutView');
	
	/**
	 * Booking current information
	 * 
	 * @class BookingInfoView
	 */
	return LayoutView.extend({
	
	    template: '#booking_info',
	    modelEvents: {
	    	'change': 'render'
	    },
        _bookingStepManager: null,

		initialize: function (options) {
			this._bookingStepManager = this.getOption('bookingStepManager');

	    	this.listenTo(this.getOption('clientTimeZone'), 'sync', this.render);
			this.listenTo(this._bookingStepManager, 'stepsChanged', this.render);
		},

        serializeData: function () {
		    var result = LayoutView.prototype.serializeData.apply(this);
            result.time_diff = this.getOption('clientTimeZone').get('time_diff');
            result.steps = this._bookingStepManager.getVisibleSteps();
			result.currentStep = this.getOption('currentStep');
            
            var attributeNames = _.pluck(
                _.filter(this.model.get('products'), function (product) { 
                    return product.type == 'attribute' && ~~product.qty >= 1
                }), 
                'name'
            );

            result.paid_attribute_names = attributeNames.length
				? attributeNames.join(', ')
				: this.model.get('service_id') && result.currentStep !== 'paid_attributes'
					? Locale.getNonEscape('paid_attribute_no_addons')
					: '';

			result.passedSteps = result.steps.slice(0, Math.max(_.indexOf(result.steps, result.currentStep), 0));

			Backbone.Wreqr.radio.vent.trigger('data', 'serialize', {
				'module': 'booking_info',
				'data': result
			});

			//do not change date in view if its waiting list
			if(result.wl && parseInt(result.wl)){
				result.start_time = null;
				result.time_diff = 0;
			}

            return result;
        },

		onDomRefresh: function () {
			Backbone.Wreqr.radio.vent.trigger('module', 'shown', {
				'module': 'booking_info'
			});
		}
	    
	});
	
});
